if (!customElements.get('caelene-mini-reviews')) {
  customElements.define('caelene-mini-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.busy = false;
      this.addEventListener('mouseenter', () => { this.busy = true; });
      this.addEventListener('mouseleave', () => { this.busy = false; });
      this.addEventListener('focusin', () => { this.busy = true; });
      this.addEventListener('focusout', () => { this.busy = false; });
      this.querySelector('[data-cmr-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-cmr-next]').addEventListener('click', () => this.show(this.index + 1));
      this.observer = new MutationObserver(() => this.readReviews());
      this.observer.observe(document.body, {childList: true, subtree: true});
      this.readReviews();
      this.timeout = setTimeout(() => this.observer.disconnect(), 30000);
    }
    readReviews() {
      if (this.slides) return;
      const seen = new Set();
      const reviews = [];
      document.querySelectorAll('.trustnew-theme-card').forEach(card => {
        const quote = card.querySelector('p.tw-break-words')?.textContent.trim();
        const name = card.querySelector('p.tw-truncate')?.textContent.trim();
        const stars = card.querySelectorAll('svg.bk-fill-secondary').length;
        if (!quote || !name || seen.has(quote) || quote.length > 180 || stars < 1 || stars > 5) return;
        seen.add(quote);
        reviews.push({quote, name, stars});
      });
      if (reviews.length < 3) return;
      this.observer.disconnect();
      const container = this.querySelector('.cmr-slides');
      reviews.slice(0, 3).forEach(review => {
        const slide = document.createElement('div');
        slide.className = 'cmr-slide';
        const avatar = document.createElement('span');
        avatar.className = 'cmr-avatar';
        avatar.setAttribute('aria-hidden', 'true');
        avatar.textContent = review.name.split(/\s+/).map(n => n[0]).join('').slice(0, 2);
        const body = document.createElement('div');
        const meta = document.createElement('div');
        meta.className = 'cmr-meta';
        const name = document.createElement('strong');
        name.textContent = review.name;
        const stars = document.createElement('span');
        stars.className = 'cmr-stars';
        stars.textContent = '★'.repeat(review.stars);
        stars.setAttribute('aria-label', review.stars + ' von 5 Sternen');
        const quote = document.createElement('p');
        quote.className = 'cmr-quote';
        quote.textContent = review.quote;
        meta.append(name, stars);
        body.append(meta, quote);
        slide.append(avatar, body);
        container.append(slide);
      });
      this.slides = Array.from(container.children);
      this.hidden = false;
      this.show(0);
      this.interval = setInterval(() => {
        if (!this.paused && !this.busy && !document.hidden) this.show(this.index + 1);
      }, 6000);
    }
    show(index) {
      if (!this.slides) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-cmr-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearInterval(this.interval);
      clearTimeout(this.timeout);
    }
  });
}
